import React from 'react'
import {
  CashStack,
  Check2Circle,
  Clock,
  JournalText,
  ArrowRight
} from 'react-bootstrap-icons'

export default function Pricing() {
  return (
    <section id="pricing" className="py-5 section-light pricingSection">
      <div className="container">
        <div className="pricingHeading text-center mb-5">
          <div className="eyebrowWrap justify-content-center">
            <span className="eyebrowLine"></span>
            <p className="aboutEyebrow mb-0">FEES</p>
            <span className="eyebrowLine"></span>
          </div>

          <h1 className="brand-text-dark mb-3">Pricing</h1>
          <p className="pricingIntro mb-0">
            Clear, simple pricing, with the option to save through block bookings.
          </p>
        </div>

        <div className="row g-4">
          <div className="col-12 col-lg-7">
            <div className="pricingCard pricingCard-main h-100">
              <div className="pricingIcon">
                <CashStack />
              </div>

              <div className="pricingLabel">Session fee</div>

              <div className="pricingPriceWrap">
                <h2 className="pricingPrice mb-1">£85</h2>
                <p className="pricingSub mb-0">Per individual session</p>
              </div>

              <div className="pricingDivider"></div>

              <div className="pricingPackageList">
                <div className="pricingPackageItem">
                  <div className="pricingPackageTop">
                    <div className="pricingPackageTitle">
                      <Check2Circle />
                      <span>Single session</span>
                    </div>
                    <div className="pricingPackageAmount">£85</div>
                  </div>
                </div>

                <div className="pricingPackageItem pricingPackageHighlight">
                  <div className="pricingPackageTop">
                    <div className="pricingPackageTitle">
                      <ArrowRight />
                      <span>3-session block</span>
                    </div>
                    <div className="pricingPackageAmount">£220</div>
                  </div>
                  <div className="pricingPackageMeta">
                    Saving of £35 · £73 per session
                  </div>
                </div>

                <div className="pricingPackageItem pricingPackageHighlight">
                  <div className="pricingPackageTop">
                    <div className="pricingPackageTitle">
                      <ArrowRight />
                      <span>4-session block</span>
                    </div>
                    <div className="pricingPackageAmount">£280</div>
                  </div>
                  <div className="pricingPackageMeta">
                    Saving of £60 · £70 per session
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-lg-5">
            <div className="pricingCard h-100">
              <div className="pricingNotesHeader">
                <div className="pricingIcon pricingIcon-soft">
                  <JournalText />
                </div>
                <div>
                  <h3 className="pricingNotesTitle mb-1">Things to know</h3>
                  <p className="pricingNotesText mb-0">
                    A few important details before booking.
                  </p>
                </div>
              </div>

              <div className="pricingNotesList mt-4">
                <div className="pricingNoteItem">
                  <div className="pricingNoteIcon">
                    <Check2Circle />
                  </div>
                  <p className="mb-0">
                    If you are a full-time student, concession rates may be
                    available for a limited number of sessions. Please enquire.
                    Proof will be required.
                  </p>
                </div>

                <div className="pricingNoteItem">
                  <div className="pricingNoteIcon">
                    <Clock />
                  </div>
                <p className="mb-0">
  48 hours’ notice is required to avoid cancellation fees, unless in emergency situations. Full cancellation details will be shared with you, outlining the policy in more detail.
</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}